'use client'

import { useQuery } from '@tanstack/react-query'
import { useLocale, useTranslations } from 'next-intl'

import CommunityLoading from 'component/block/loading/community-loading'
import NoQueryResult from 'component/block/no-content/query-result'
import CommunityWithComments from 'component/page/community/community-with-comments'
import { TEMP_USER_ID } from 'constant'
import { fetchSearchCommunities } from 'server-actions/fetch-search'
import { useIpLocationStore } from 'store/server-context/ip-location'
import { useSessionStore } from 'store/server-context/session'

interface ICommunityResult {
  queryKeywords: string
}
const CommentsResult = ({ queryKeywords }: ICommunityResult) => {
  const t = useTranslations()
  const locale = useLocale()
  const session = useSessionStore(state => state.session)
  const ipLocation = useIpLocationStore(state => state.ipLocation)

  const { data, isLoading } = useQuery({
    queryKey: ['searchResultCommunity', queryKeywords],
    queryFn: async () => {
      let lat = '0'
      let lng = '0'

      if (ipLocation) {
        const {
          ip_geo_point: { lat: ipLat, lng: ipLng }
        } = ipLocation
        lat = `${ipLat}`
        lng = `${ipLng}`
      }
      const searchParams = new URLSearchParams()
      searchParams.set('keyword', queryKeywords)
      searchParams.set(
        'user_id',
        session.guest ? TEMP_USER_ID : session.user_id
      )
      searchParams.set('lat', lat)
      searchParams.set('lng', lng)
      searchParams.set('country_code', ipLocation?.country_code || '')
      searchParams.set('lang', locale)

      const communities = await fetchSearchCommunities(
        searchParams.toString(),
        locale
      )

      return communities
    }
  })

  if (isLoading) {
    return <CommunityLoading />
  }

  if (data?.length === 0) {
    return (
      <NoQueryResult className='m-auto max-w-[432px] py-[32px] text-center'>
        {t('search.no_result.keyword', {
          search_term: queryKeywords
        })}
      </NoQueryResult>
    )
  }

  return data?.map(community => (
    <CommunityWithComments
      key={`${community.id}`}
      comment={community.comments}
      isCommunityPageLink
    />
  ))
}

export default CommentsResult
